import { statusLabel, type StoreStatus } from "../lib/util";

export function StatusPill({ status }: { status: StoreStatus }) {
  return (
    <span className={`st-pill st-pill--${status}`}>
      <span className={`st-dot st-dot--${status}`} />
      {statusLabel(status)}
    </span>
  );
}
